import axios from 'axios';
import { isDemoMode } from 'config/demo-mode';

export interface ApiErrorResponse {
  success: false;
  error: {
    message: string;
    code: string;
  };
  meta?: {
    request_id?: string;
  };
}

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:4001',
  withCredentials: true,
  timeout: 15_000,
  headers: {
    'Content-Type': 'application/json'
  }
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!isDemoMode && isUnauthorizedError(error) && window.location.pathname !== '/login') {
      window.dispatchEvent(new Event('mineacs:unauthorized'));
    }

    return Promise.reject(error);
  }
);

export function getApiErrorMessage(error: unknown): string {
  if (axios.isAxiosError<ApiErrorResponse>(error)) {
    return error.response?.data?.error?.message || error.message || 'Unable to complete the request';
  }

  if (error instanceof Error) {
    return error.message;
  }

  return 'An unexpected error occurred';
}

export function isUnauthorizedError(error: unknown): boolean {
  return axios.isAxiosError(error) && error.response?.status === 401;
}
